// @flow
import styled from "styled-components";

export const Rotate = styled.div`
	transform: rotate(${({ rotate }) => `${rotate}deg` || 0});
`;

export default Rotate;